var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative overflow-hidden"},[_c('transition',{attrs:{"name":"bounce"}},[_c('Child')],1),_c('div',{staticClass:"earth-fixed__img"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }